import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../Store";
import type { UserSettings } from "../../services/UserSettingsService";

interface UserSettingsState {
  settings: UserSettings | null;
  isLoaded: boolean;
  loadFailed: boolean;
  isSaving: boolean;
}

const initialState: UserSettingsState = {
  settings: null,
  isLoaded: false,
  loadFailed: false,
  isSaving: false,
};

export const userSettingsSlice = createSlice({
  name: "userSettings",
  initialState,
  reducers: {
    setUserSettingsLoaded: (
      state,
      action: PayloadAction<UserSettings | null>
    ) => {
      state.settings = action.payload;
      state.isLoaded = true;
      state.loadFailed = false;
      state.isSaving = false;
    },
    setUserSettingsLoadFailed: (state) => {
      state.settings = null;
      state.isLoaded = false;
      state.loadFailed = true;
      state.isSaving = false;
    },
    setUserSettingsSaving: (state) => {
      state.isSaving = true;
    },
    setUserSettingsSaveSucceeded: (
      state,
      action: PayloadAction<UserSettings>
    ) => {
      state.settings = action.payload;
      state.isLoaded = true;
      state.loadFailed = false;
      state.isSaving = false;
    },
    setUserSettingsSaveFailed: (state) => {
      state.isSaving = false;
    },
    clearUserSettings: (state) => {
      state.settings = null;
      state.isLoaded = false;
      state.loadFailed = false;
      state.isSaving = false;
    },
  },
});

export const {
  setUserSettingsLoaded,
  setUserSettingsLoadFailed,
  setUserSettingsSaving,
  setUserSettingsSaveSucceeded,
  setUserSettingsSaveFailed,
  clearUserSettings,
} = userSettingsSlice.actions;

export const selectUserSettings = (state: RootState) =>
  state.userSettings.settings;
export const selectUserSettingsIsLoaded = (state: RootState) =>
  state.userSettings.isLoaded;
export const selectUserSettingsLoadFailed = (state: RootState) =>
  state.userSettings.loadFailed;
export const selectUserSettingsIsSaving = (state: RootState) =>
  state.userSettings.isSaving;

export default userSettingsSlice.reducer;
